var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: { inputRange: true, countPopUpActive: _vm.popUpIsActive } },
    [
      _c("input", {
        attrs: { type: "range", min: _vm.valueMin, max: _vm.valueMax },
        domProps: { value: _vm.value },
        on: { input: _vm.onChange },
      }),
      _c(
        "div",
        {
          staticClass: "countPopUp",
          style: {
            left:
              (_vm.value / (_vm.valueMax - _vm.valueMin)) * 100 * 0.974 + "%",
          },
        },
        [_vm._v("\n        " + _vm._s(_vm.value) + "\n    ")]
      ),
      _c("div", {
        staticClass: "progression",
        style: {
          width: (_vm.value / (_vm.valueMax - _vm.valueMin)) * 100 + "%",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }